<template>
	<div>
		<form-rating v-model.number="data.rating" :label="$t('label.rating')" class="text-center" :rules="{required: true}" x-large center/>
		<p class="text-gray-400 pl-8 mb-20 leading-spaced text-center h-36">{{ data.rating ? $t('param_label.stars', data.rating, {count: data.rating}) : $t('input.event_rating.rating') }}</p>

		<form-textarea v-model="data.description" name="description" :label="$t('input.event_rating.description')"
					   :rows="5"
					   :placeholder="$t('help.event_rating.description')"
					   :help="$t('help.event_rating.description')"/>

		<form-switch v-model="data.private" name="private" :label="$t('input.event_rating.private')"
					 :help="$t('help.event_rating.private')"/>
	</div>
</template>

<script>

import {FormInputsMixin} from "@spoferan/nuxt-spoferan/mixins";

export default {

	name: 'EventRatingFormInputs',

	mixins: [FormInputsMixin],
}
</script>